import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy } from 'swiper';
import {toLower} from 'lodash-es'
// Install modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy ]);

export default function() {
    const tiles = document.querySelector('.benefit_tiles');

    if(tiles) {
        const tileSwiper = document.querySelectorAll('.benefit_tiles__wrapper');
        if(window.innerWidth < 768) {
            tileSwiper.forEach((element) => {
                let params = JSON.parse(element.dataset.benefitSwiper);
                console.log(params)
                new Swiper(element, params);
            });
        }
    }

    window.addEventListener('resize', function(event) {
        if(tiles) {
            const tileSwiper = document.querySelectorAll('.benefit_tiles__wrapper');
            const tileSlide = document.querySelectorAll('.benefit_tiles__tile'); 
            if(window.innerWidth < 768) {
                tileSwiper.forEach((element) => {
                    let params = JSON.parse(element.dataset.benefitSwiper);
                    new Swiper(element, params);
                });
                tileSlide.forEach((slide) => {
                    slide.removeAttribute('data-aos')
                })
            } else {
                tileSwiper.forEach((element) => {
                    let swiper = element.swiper
                    if(swiper) {
                        console.log(swiper)
                        swiper.destroy(true, true)
                    }
                })
            }
        }
    })
}